import { defineLanguage } from '../../../src/domain/language/factory';

export default defineLanguage({
  languageName: 'Turkish',
  languageCode: 'tr',
  languageHeaderCode: 'tr',
});
